import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setMenuOpen(false); }, [location]);
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const links = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About' },
    { to: '/industries', label: 'Industries' },
  ];

  return (
    <nav className="navbar">
      <div className="navbar__inner">
        {/* Logo */}
        <Link to="/" className="navbar__logo">
          <img
            src="https://cdn.prod.website-files.com/68234acd8fb1ab421a72b174/6835a18d5509df5179891345_Renart_Social_Primary.png"
            alt="Renart"
          />
        </Link>

        {/* Desktop: pill + contact */}
        <div className="navbar__right">
          <div className="navbar__pill">
            {links.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`navbar__link${location.pathname === link.to ? ' active' : ''}`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/contact" className="navbar__contact-btn">
              <span>Contact</span>
              <div className="navbar__contact-circle">
                <svg className="arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"/>
                </svg>
              </div>
            </Link>
          </div>
        </div>

        {/* Mobile:  burger  +  contact pill */}
        <div className="navbar__mobile-controls">
          <button
            className={`navbar__burger${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <div className="burger-wrap">
              <span className="burger-line top"></span>
              <span className="burger-line middle"></span>
              <span className="burger-line bottom"></span>
            </div>
          </button>

          <Link to="/contact" className="navbar__contact-btn">
            <span>Contact</span>
            <div className="navbar__contact-circle">
              <svg className="arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"/>
              </svg>
            </div>
          </Link>
        </div>
      </div>

      {/* Mobile menu overlay */}
      <div className={`navbar__mobile${menuOpen ? ' open' : ''}`}>
        <ul>
          {links.map(link => (
            <li key={link.to}>
              <Link to={link.to} className={location.pathname === link.to ? 'active' : ''}>
                {link.label}
              </Link>
            </li>
          ))}
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
}